module.exports = __webpack_public_path__ + "static/media/People.2780fd91.png";